/*多行列表项组件*/
<template>
	<div class="multilineListItems">
		<template v-for="(item, index) in tableData.itemsList">
			<div class="items" v-if="item.show ? item.show(scope, item) : true" :key="index">
				<customComponent
					v-if="item.type === 'custom'"
					:component-name="item.componentName"
					:scope="scope"
					:table-data="item"
				></customComponent>
				<component
					v-else
					:is="item['type'] || 'defaultText'"
					:scope="scope"
					:tableData="item"
					:key="index"
					v-on="$listeners"
				></component>
			</div>
		</template>
	</div>
</template>

<script>
import columnBtn from './columnBtn';
import defaultText from './defaultText';
import customComponent from '@/components/tools/customComponent';
import skySortSelect from '@/components/iglobalwin/formComponents/sky-sortSelect';
import btnClick from './btnClick';
import remark from './remark';
import progressItem from './progress';
import expandBtn from './expandBtn';
import account from './account/index.js';
import tableExpand from './tableExpand';
import tag from './tag.vue';
import functionalZone from '@/components/iglobalwin/dataList/functionalZone.vue';
import previewUploadFile from './preview-uploadimg';
import multilineListItems from './multilineListItems.vue';

export default {
	name: 'multilineListItems',
	props: {
		tableData: Object,
		scope: Object,
	},
	components: {
		...account,
		columnBtn,
		defaultText,
		customComponent,
		btnClick,
		skySortSelect,
		remark,
		progressItem,
		expandBtn,
		tableExpand,
		tag,
		functionalZone,
		previewUploadFile,
		multilineListItems,
	},
};
</script>

<style lang="scss" scoped>
.multilineListItems {
}
</style>
